// extracted by mini-css-extract-plugin
export default {"imageWrapper":"JI-z","twoColumnImage":"KI-z"};